<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/AdministrativeLocations">Administrative Locations</b-breadcrumb-item>
            <b-breadcrumb-item active>{{administrativeLocation.id}}</b-breadcrumb-item>
        </b-breadcrumb>

        <AppLoadingContainer :predicate="!isLoaded">
            <form @submit.prevent="onSubmit()">
                <div class="card">
                    <div class="bg-dark card-header text-white">Edit Adloc</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4 col-sm-12 form-group">
                                <label for="Id">Number</label>
                                <input autocomplete="off" class="form-control" disabled
                                       v-model="administrativeLocation.id"/>
                            </div>
                            <div class="col-md-8 col-sm-12 form-group">
                                <label for="Description">Description</label>
                                <input :class="{'is-invalid': $v.administrativeLocation.description.$invalid}"
                                       class="form-control"
                                       maxlength="60"
                                       placeholder="Description" v-model="administrativeLocation.description"/>
                                <span class="invalid-feedback" v-if="!$v.administrativeLocation.description.required">Field is required</span>
                                <span class="invalid-feedback" v-if="!$v.administrativeLocation.description.maxLength">Description must be &le; 60 characters</span>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer d-print-none text-right">
                        <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                        <RouterLink :to="{name:'AdministrativeLocations'}" class="btn btn-danger">Back</RouterLink>
                    </div>
                </div>
            </form>
        </AppLoadingContainer>


    </div>
</template>

<script>
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {ToastType} from "@/services/models/shared/ToastType";
    import AdministrativeLocationService from "@/services/AdministrativeLocationService";
    import {maxLength, required} from "vuelidate/lib/validators";

    export default {
        components: {
            AppLoadingContainer
        },
        data() {
            return {
                administrativeLocation: {
                    id: null,
                    description: null
                },
                isSubmitting: false,
                isLoaded: false
            }
        },
        methods: {
            /**
             * @description Updates an adloc and redirects if successful
             */
            onSubmit() {
                const vm = this;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;
                AdministrativeLocationService.updateAdministrativeLocation(vm.administrativeLocation).then(() => {
                    vm.alert(ToastType.Success, `The adloc '${vm.administrativeLocation.id}' was successfully updated.`);

                    // Redirect to the adlocs page
                    vm.$router.push({name: 'AdministrativeLocations'})
                }).catch(function (error) {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isSubmitting = false;
                });
            }
        },
        created() {
            this.administrativeLocation.id = this.$route.params.id;
            const vm = this;

            // Retrieve this specific administrative location
            AdministrativeLocationService.getAdministrativeLocation(this.administrativeLocation.id)
                .then(function (response) {
                    vm.administrativeLocation = response;
                }).catch(() => {
                vm.redirectToError()
            }).finally(() => {
                vm.isLoaded = true;
            });
        },
        validations: {
            administrativeLocation: {
                description: {
                    required,
                    maxLength: maxLength(60)
                }
            }
        }
    }
</script>
